import { Box, Flex } from '@chakra-ui/react';

export const BalanceItem = ({
	label,
	symbol,
	value,
	reverseAlign,
}: {
	label: string;
	symbol: string;
	value: string;
	reverseAlign?: boolean;
}) => {
	return (
		<Flex
			flexDirection="column"
			justifyContent="center"
			alignItems={reverseAlign ? 'flex-end' : 'flex-start'}
			overflow="hidden"
			flexGrow={1}
		>
			<Box
				opacity=".5"
				userSelect="none"
			>
				{label}
			</Box>
			<Box
				fontSize="16px"
				fontWeight="bold"
				lineHeight="125%"
			>
				{value}{' '}
				<Box
					display="inline-block"
					fontSize="12px"
				>
					{symbol}
				</Box>
			</Box>
		</Flex>
	);
};
